import * as C from '../Constants'
const StateDisTable = (state={}, action) => {

    switch(action.type){
        case C.GET_TABLE_DATA:
            return{...state, TableLoading: true};
        case C.GET_TABLE_DATA_SUCCESS:
            return{...state,
                state_dis : action.state_dis,
                zone_info : action.state_zone,
                state_testing_stats : action.state_testing_stats,
                lastUpdated: action.lastUpdated,
                TableLoading: false}  
        default:
            return state;  
    }
};
export default StateDisTable